import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Spinner from '../../../../../components/Loaders/Spinner';

const Loader = ({ isFetching }) => (
  <div className={classNames({
    'service-table__loader': isFetching,
  })}
  >
    {isFetching ? <Spinner /> : null }
  </div>
);

Loader.propTypes = {
  isFetching: PropTypes.bool,
}

export default Loader;
